export * from './delete-icon.component'